(function() {
  var array_utils,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; },
    slice = [].slice;

  array_utils = App.load('core::utils/array');

  exports.RatingsValidator = (function() {
    function RatingsValidator(products, all_columns, column_groups) {
      this.products = products;
      this.all_columns = all_columns;
      this.column_groups = column_groups;
      this.evaluateReplacements = bind(this.evaluateReplacements, this);
      this.parseRuleString = bind(this.parseRuleString, this);
      this.validate = bind(this.validate, this);

      /*
      All the rules are defined here for now
      
      Validation rules are defined in the following format:
      
      - msg: The validation message that will be displayed if the cell
          contents are invalid. Any variables prefixed with a colon will be
          replaced with the appropriate value (e.g. ":column" will be
          replaced with the column's display_name, ":value" will be replaced
          with the cell contents, etc). Custom replacements can be defined on
          the result of isValid (defined below). Replacement values can be
          strings, numbers, or functions (the return value will be used).
      
      input_types (optional): An array of column input_types that this rule
          can be applied to. If defined, an error will be thrown if the rule
          is applied to any other input_type.
      
      isValid: A function that be called to determine if the cell's value is
          valid. The parameters passed to this function include the column
          definition, the product object, the value of the cell, and then any
          custom parameters defined in validation_rules array on the column
          definition. Note that they will be passed in as string values in
          the order they are specified. The function must return either a
          boolean (simplest), a Promise that resolves to a boolean (for async
          validation), or an object with a 'is_valid' property (boolean) and an
          optional 'msg_params' property (object whose keys/values are used
          to make custom replacements in the msg).
      
      An example to tie it all together:
      
      'do_stuff':
          msg: ":column :action :something!\"
          input_types: ['text', 'autcomplete']
          isValid: (value, column, product, action, something) =>
              if value? and value isnt ''
                  return true
              else
                  if column.input_type is 'autocomplete'
                      something = something.replace('peck', 'value')
                          .replace('of pickled peppers', 'from a dropdown')
                  return {
                      is_valid: false
                      msg_params:
                          'action': action
                          'something': () ->
                              return something
                  }
      
      A column using this validation rule could be defined as follows:
      
      display_name: 'Peter Piper'
      input_type: 'autocomplete'
      validation_rules:
          'do_stuff:picks,a peck of pickled peppers'
      
      If the cell is blank, this would result in the following validation
      message being displayed:
      "Peter Piper picks a value from a dropdown!"
      
      If the column definition was as follows:
      
      display_name: 'Mr. T'
      input_type: 'text'
      validation_rules:
          'do_stuff:pities,the foo'
      
      the resulting message would be : "Mr. T pities the foo!"
       */
      this.rules = {
        'numeric': {
          msg: ':column must be a number',
          isValid: (function(_this) {
            return function(value, product, column) {
              if ((value == null) || value === '') {
                return true;
              }
              return $.isNumeric(value);
            };
          })(this)
        },
        'integer': {
          msg: ':column must be a whole number',
          isValid: (function(_this) {
            return function(value, product, column) {
              if ((value == null) || value === '') {
                return true;
              }
              return $.isNumeric(value) && (value % 1 === 0);
            };
          })(this)
        },
        'boolean': {
          msg: ':column must be a true/false value',
          isValid: (function(_this) {
            return function(value, product, column) {
              if ((value == null) || value === '') {
                return true;
              }
              return value === true || value === false;
            };
          })(this)
        },
        'min': {
          msg: ':column cannot be :comparison :min :units',
          input_types: ['numeric', 'text'],
          isValid: (function(_this) {
            return function(value, product, column, min) {
              var comparison, units;
              if ((value == null) || value === '') {
                return true;
              }
              min = parseFloat(min);
              switch (column.input_type) {
                case 'numeric':
                  if (value >= min) {
                    return true;
                  }
                  comparison = 'less than';
                  units = '';
                  break;
                case 'text':
                  if (value.length >= min) {
                    return true;
                  }
                  comparison = 'shorter than';
                  units = 'characters';
              }
              return {
                is_valid: false,
                msg_params: {
                  'min': min,
                  'comparison': comparison,
                  'units': units
                }
              };
            };
          })(this)
        },
        'max': {
          msg: ':column cannot be :comparison :max :units',
          input_types: ['numeric', 'text'],
          isValid: (function(_this) {
            return function(value, product, column, max) {
              var comparison, units;
              if ((value == null) || value === '') {
                return true;
              }
              max = parseFloat(max);
              switch (column.input_type) {
                case 'numeric':
                  if (value <= max) {
                    return true;
                  }
                  comparison = 'greater than';
                  units = '';
                  break;
                case 'text':
                  if (value.length <= max) {
                    return true;
                  }
                  comparison = 'longer than';
                  units = 'characters';
              }
              return {
                is_valid: false,
                msg_params: {
                  'max': max,
                  'comparison': comparison,
                  'units': units
                }
              };
            };
          })(this)
        },
        'min_column': {
          msg: ':column cannot be less than :min_column',
          input_types: ['numeric'],
          isValid: (function(_this) {
            return function(value, product, column, min_prop) {
              var min;
              if (!$.isNumeric(value)) {
                return true;
              }
              min = product[min_prop];
              if (!$.isNumeric(min)) {
                return true;
              }
              if (value >= min) {
                return true;
              }
              return {
                is_valid: false,
                msg_params: {
                  'min_column': _this.all_columns[min_prop].display_name
                }
              };
            };
          })(this)
        },
        'max_column': {
          msg: ':column cannot be greater than :max_column',
          input_types: ['numeric'],
          isValid: (function(_this) {
            return function(value, product, column, max_property) {
              var max;
              if (!$.isNumeric(value)) {
                return true;
              }
              max = product[max_property];
              if (!$.isNumeric(max)) {
                return true;
              }
              if (value <= max) {
                return true;
              }
              return {
                is_valid: false,
                msg_params: {
                  'max_column': _this.all_columns[max_property].display_name
                }
              };
            };
          })(this)
        },
        'in_options': {
          msg: '\":value\" is not a valid option for :column',
          input_types: ['autocomplete'],
          isValid: (function(_this) {
            return function(value, product, column) {
              var options, ref;
              if ((value == null) || value === '') {
                return true;
              }
              options = _.map(column.getOptions(product), function(option) {
                return option.toString().trim();
              });
              return (ref = value.toString().trim(), indexOf.call(options, ref) >= 0);
            };
          })(this)
        },
        'is_product': {
          msg: '\":value\" is not a Product that exists in your lineup. To add it, click the Add Product button in the sidebar.',
          input_types: ['autocomplete'],
          isValid: (function(_this) {
            return function(value, product, column) {
              if ((value == null) || value === '') {
                return true;
              }
              return _.find(_this.products, {
                full_name: value
              }) != null;
            };
          })(this)
        },
        'unique_refuge_option': {
          msg: ':value cannot be selected for more than once for the same Product.',
          input_types: ['autocomplete'],
          isValid: (function(_this) {
            return function(value, product, column) {
              var i, len, other_refuge, prop, ref, refuge;
              refuge = _.find(_this.products, {
                full_name: value
              });
              if (refuge == null) {
                return true;
              }
              ref = _this.column_groups.refuge_option;
              for (i = 0, len = ref.length; i < len; i++) {
                prop = ref[i];
                if (prop === column.column_alias) {
                  continue;
                }
                other_refuge = _.find(_this.products, {
                  full_name: product[prop]
                });
                if (other_refuge == null) {
                  continue;
                }
                if (other_refuge === refuge) {
                  return false;
                }
              }
              return true;
            };
          })(this)
        },
        'required': {
          msg: ':column is required',
          isValid: (function(_this) {
            return function(value, product, column) {
              if ((value != null) && value !== '') {
                return true;
              }
              return false;
            };
          })(this)
        },
        'is_valid_refuge': {
          msg: 'This product cannot be used as a refuge option because you have indicated that it requires a structured refuge.',
          input_types: ['checkbox'],
          isValid: (function(_this) {
            return function(value, product, column) {
              if (!value) {
                return true;
              }
              return product.isAValidRefugeOption(_this.column_groups.refuge_percent);
            };
          })(this)
        },
        'has_refuge_available': {
          msg: 'You have indicated that :product is tolerant to :chemistry_traits, but have not defined a compatible Refuge Product. You must either define a Refuge Product with :chemistry_options tolerance, or change :chemistry_traits to 0 to ensure that this product is not recommended for use with :chemistry_options.',
          input_types: ['autocomplete'],
          isValid: (function(_this) {
            return function(value, product, column) {
              var available_options, column_to_validate, i, len, missing_traits, prop, ref, ref1, refuge_products;
              if (product.isAValidRefugeOption(_this.column_groups.refuge_percent)) {
                return true;
              }
              if (ref = column.column_alias, indexOf.call(_this.column_groups.refuge_option, ref) >= 0) {
                ref1 = _this.column_groups.refuge_option;
                for (i = 0, len = ref1.length; i < len; i++) {
                  prop = ref1[i];
                  column_to_validate = prop;
                  if (prop === column.column_alias) {
                    if ((value == null) || value === '') {
                      break;
                    }
                  } else {
                    if ((product[prop] == null) || product[prop] === '') {
                      break;
                    }
                  }
                }
                if (column.column_alias !== column_to_validate) {
                  return true;
                }
              }
              available_options = column.getOptions(product);
              refuge_products = available_options.map(function(product_name) {
                return _.find(_this.products, {
                  full_name: product_name
                });
              });
              missing_traits = product.getMissingRefugeChemistries(refuge_products, _this.column_groups.chemistry);
              if (missing_traits.length === 0) {
                return true;
              }
              missing_traits = missing_traits.map(function(prop) {
                return _this.all_columns[prop].display_name;
              });
              return {
                is_valid: false,
                msg_params: {
                  'chemistry_traits': array_utils.joinPretty(missing_traits),
                  'chemistry_options': array_utils.joinPretty(missing_traits, 'and/or')
                }
              };
            };
          })(this)
        },
        'has_refuge_selected': {
          msg: 'You have indicated that :product is tolerant to :chemistry_traits, but have not selected a compatible Refuge Option. You must either select a Refuge Option with :chemistry_options tolerance, or change :chemistry_traits to 0 to ensure that this product is not recommended for use with :chemistry_options.',
          input_types: ['autocomplete'],
          isValid: (function(_this) {
            return function(value, product, column) {
              var available_options, available_products, column_to_validate, i, len, missing_traits, prop, ref, ref1, selected_products;
              if (product.isAValidRefugeOption(_this.column_groups.refuge_percent)) {
                return true;
              }
              if (ref = column.column_alias, indexOf.call(_this.column_groups.refuge_option, ref) >= 0) {
                ref1 = _this.column_groups.refuge_option;
                for (i = 0, len = ref1.length; i < len; i++) {
                  prop = ref1[i];
                  column_to_validate = prop;
                  if (prop === column.column_alias) {
                    if ((value == null) || value === '') {
                      break;
                    }
                  } else {
                    if ((product[prop] == null) || product[prop] === '') {
                      break;
                    }
                  }
                }
                if (column.column_alias !== column_to_validate) {
                  return true;
                }
              }
              available_options = column.getOptions(product);
              available_products = available_options.map(function(product_name) {
                return _.find(_this.products, {
                  full_name: product_name
                });
              });
              missing_traits = product.getMissingRefugeChemistries(available_products, _this.column_groups.chemistry);
              if (missing_traits.length > 0) {
                return true;
              }
              selected_products = _this.column_groups.refuge_option.map(function(prop) {
                if (prop === column.column_alias) {
                  return _.find(_this.products, {
                    full_name: value
                  });
                } else {
                  return _.find(_this.products, {
                    full_name: product[prop]
                  });
                }
              }).filter(function(refuge_product) {
                return refuge_product != null;
              });
              missing_traits = product.getMissingRefugeChemistries(selected_products, _this.column_groups.chemistry);
              if (missing_traits.length === 0) {
                return true;
              }
              missing_traits = missing_traits.map(function(prop) {
                return _this.all_columns[prop].display_name;
              });
              return {
                is_valid: false,
                msg_params: {
                  'chemistry_traits': array_utils.joinPretty(missing_traits),
                  'chemistry_options': array_utils.joinPretty(missing_traits, 'and/or')
                }
              };
            };
          })(this)
        }
      };
    }

    RatingsValidator.prototype.validate = function(rule_str, cell, product, column, get_messages, callback) {
      var doCallback, ref, result, rule, rule_obj, rule_params;
      ref = this.parseRuleString(rule_str, column), rule = ref[0], rule_obj = ref[1], rule_params = ref[2];
      result = rule_obj.isValid.apply(rule_obj, [cell.value, product, column].concat(slice.call(rule_params)));
      doCallback = (function(_this) {
        return function(is_valid, msg_params) {
          var key, msg, replacements, val;
          if (msg_params == null) {
            msg_params = {};
          }
          if (is_valid) {
            return callback(true);
          } else if (!get_messages) {
            return callback(false);
          } else {
            replacements = _this.evaluateReplacements(cell, product, column, msg_params);
            msg = rule_obj.msg;
            for (key in replacements) {
              val = replacements[key];
              msg = msg.replace(":" + key, val);
            }
            return callback(false, msg);
          }
        };
      })(this);
      switch (typeof result) {
        case 'boolean':
          return doCallback(result);
        case 'object':
          if (result.is_valid != null) {
            return doCallback(result.is_valid, result.msg_params);
          } else if (result.then != null) {
            return result.then((function(_this) {
              return function(is_valid) {
                return doCallback(is_valid);
              };
            })(this));
          } else {
            throw "Error: the '" + rule + "' validation rule returned an invalid result for the '" + column.display_name + "' column (value was '" + cell.value + "'). The result must be a boolean, a Promise object, or an object with an 'is_valid' property.";
          }
      }
    };

    RatingsValidator.prototype.parseRuleString = function(rule_str, column) {
      var input_types_str, param_str, ref, ref1, ref2, rule, rule_obj, rule_params;
      ref = rule_str.split(':', 2), rule = ref[0], param_str = ref[1];
      if (this.rules[rule] == null) {
        throw "Error: '" + rule + "' is not defined as a validation rule. In order to use it, you must add it to the RatingsValidator.";
      }
      rule_obj = this.rules[rule];
      if (typeof rule_obj.isValid !== 'function' || typeof rule_obj.msg !== 'string') {
        throw "Error: '" + rule + "' is not a valid validation rule. The definition must include an 'isValid' method and a 'msg' property.";
      }
      if (((ref1 = rule_obj.input_types) != null ? ref1.length : void 0) > 0) {
        if (ref2 = column.input_type, indexOf.call(rule_obj.input_types, ref2) < 0) {
          input_types_str = array_utils.joinPretty(rule_obj.input_types.map(function(input_type) {
            return "'" + input_type + "'";
          }));
          throw "Error: the '" + rule + "' validation rule cannot be applied to the '" + column.display_name + "' column because the input_type is '" + column.input_type + "' input type. Only " + input_types_str + " columns can be used with the '" + rule + "' rule.";
        }
      }
      if (param_str != null ? param_str.length : void 0) {
        rule_params = param_str.split(',').map(function(val) {
          return val.trim() || null;
        });
      }
      return [rule, rule_obj, rule_params != null ? rule_params : []];
    };

    RatingsValidator.prototype.evaluateReplacements = function(cell, product, column, msg_params) {
      var key, replacements, val;
      replacements = {
        'value': cell.value,
        'product': product.full_name,
        'column': column.display_name
      };
      for (key in msg_params) {
        val = msg_params[key];
        if (typeof val === 'function') {
          replacements[key] = val();
        } else {
          replacements[key] = val;
        }
      }
      return replacements;
    };

    return RatingsValidator;

  })();

}).call(this);
